import supabase  from "../config/supabaseClient"
import { useEffect,useState } from "react"
import FanyCard from "../components/fanyCard"

const Home = () => {
const [fetchError, setFetchError]=useState(null)
const [fanylife, setFany]=useState(null)
const handleDelete = (id) => {
  setFany(prevFany => {
    return prevFany.filter(sm => sm.id !== id)
  })
}
useEffect(()=>{
  const fetchFany = async ()=>{
    const {data, error } = await supabase
     .from('fanytable')
     .select()

     if(error) {
      setFetchError('Could not fetch the fany') 
      setFany(null)
      console.log(error)
     }

     if(data) {
      setFany(data)
      setFetchError(null)
     }
  }

  fetchFany()

},[])

  return (
    <div className="page home">
      {fetchError && (<p>{fetchError}</p>)}
      {fanylife && (
       <div className="fanylife"> 
       <div className="fany-grid">
       {
        fanylife.map(fany=>(
          <FanyCard key={fany.id} fany ={fany} onDelete={handleDelete} />
        ))}
       </div>

       </div>

      )

      }
    </div>
  )
}

export default Home